import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Text, Button, Box } from '@rsos/components/capstone/base';
import onLogout from '@rsos/utils/onLogout';
import { Wrapper, Content, StyledAnchor } from './ErrorPage.styles';
import { trackLogOutClick } from './errorPageTrackings';

// persistor is optional: apps that don't persist Redux state (e.g. the
// consolidated admin app) render <ErrorPage /> with no persistor (an omitted
// prop is undefined), and onLogout simply skips the flush.
/**
 * @param {{ persistor?: any }} props
 */
const ErrorPage = ({ persistor }) => {
  const dispatch = useDispatch();
  const currentApp = useSelector(
    state => state.sinatra.user.currentRole.application,
  );
  const irpVersion = useSelector(state => state.sinatra.irp.irpVersion);

  const handleLogout = () => {
    trackLogOutClick(currentApp, irpVersion);
    return onLogout(persistor, dispatch);
  };

  return (
    <Wrapper>
      <Content>
        <Box horizontal flow={8} align="center">
          <AttentionTriangleIcon width={13} color="secondaryLink" height={13} />
          <Text size="large" color="primaryText" fontWeight="bold">
            Error loading page
          </Text>
        </Box>
        <Text size="normal" color="secondaryText" textAlign="center">
          An unexpected error occured. You may navigate to another page using
          the menu above. If this error persists, please contact{' '}
          <Text underline color="primaryBase" inline>
            <StyledAnchor
              href="mailto:support@rapidsos.com?subject=Error Loading Page"
              target="_blank"
              rel="noopener noreferrer"
            >
              support@rapidsos.com
            </StyledAnchor>
          </Text>
        </Text>
        <Button btnType="tertiary" onClick={handleLogout}>
          Log out
        </Button>
      </Content>
    </Wrapper>
  );
};

export default ErrorPage;
